import Vue from 'vue';
import Vuex from 'vuex';

import alerts from './modules/alerts';
import auth from './modules/auth';
import currencies from './modules/currencies';
import dialCodes from './modules/dialCodes';
import images from './modules/images';
import languages from './modules/languages';
import orders from './modules/orders';
import orderCredits from './modules/orderCredits';
import packetLabel from './modules/packetLabel';
import settings from './modules/settings';
import stores from './modules/stores';
import users from './modules/users';
import page from './modules/page';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    alerts,
    auth,
    currencies,
    dialCodes,
    images,
    languages,
    orders,
    orderCredits,
    packetLabel,
    settings,
    stores,
    users,
    page,
  },
});
